<template>
  <div class="am-ClockIn">
   <span>
  <a :disabled="isDisabled"  @click="clockInOut()">
    <svg-icon :icon="toggleIcon" :title="toggleTitle" class="am-glyphicon-large am-glyphicon-blue"></svg-icon>
  </a>
</span>
    <span v-bind:class="[data.type === 'In' ? 'reverse-green' : 'reverse-red']"> {{ data.type }} {{ data.clock }}</span>
  </div>
</template>

<script>
import api from './../http'
import config from './../config/global.config'

export default {
  data: function () {
    return {
      data: {
        type: 'In',
        clock: ''
      },
      isDisabled: false
    }
  },

  asyncComputed: {
    currentStatus: {
      get () {
        let self = this
        api.get(config.applicationUrl('/time_tracking/clock/get_status')).then(
          (data) => {
            self.data = data.data
          }
        )
      }
    }
  },

  computed: {
    toggleIcon() {
      return this.data.type === 'In' ? 'clockOut' : 'clockIn'
    },
    toggleTitle(){
      return this.data.type === 'In' ?'Clock Out' : 'Clock In'
    }
  },

  methods: {
    clockIn () {
      let self = this
      api.get(config.applicationUrl('/time_tracking/clock/in')).then(
        (data) => {
          self.isDisabled = false
          self.data = data.data
        }
      )
    },

    clockOut () {
      let self = this
      api.get(config.applicationUrl('/time_tracking/clock/out')).then(
        (data) => {
          self.isDisabled = false
          self.data = data.data
        }
      )
    },

    clockInOut () {
      this.isDisabled = true
      if (this.data.type === 'In') {
        this.clockOut()
      } else {
        this.clockIn()
      }
    }
  }
}
</script>

<style scoped>
  .am-ClockIn input[type=button] {
    font-family: Arial,Helvetica,sans-serif;
    font-size: 11px;
    padding: 3px 5px;
    background-color: #ffffef;
  }

  .reverse-red {
    background-color: #BF3628;
    color: white;
    font-size: 11px;
    font-weight: 500;
    margin-right: 6px;
  }

  .reverse-green {
    background-color: #339900;
    color: white;
  }
</style>
